import React, { useState, useEffect } from "react";
import { Topbar } from "@components";
import { useNavigate, useParams } from "react-router-dom";
import {
  RootContainer,
  Title,
  Top,
  Image,
  Loader,
  Container,
  Card,
  NoCard,
  NoText,
  Divider,
  NameCard,
  NameText,
  PhoneText,
  AmountCard,
  AmountText,
} from "./TopWinners.style";
import { Spin } from "antd";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import {
  BURMESE_LANGUAGE_CODE_LK,
  CHINESE_LANGUAGE_CODE_LK,
  WINNER_GAMES_LK,
} from "@constants";
import { useSelector } from "react-redux";
import { getFormattedNumber } from "@utils";
import { useTranslation } from "react-i18next";

const TopWinners = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { child_game_id } = useParams();
  const lang = useSelector((state) => state.app.userPreferedLanguage);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [game, setGame] = useState({});

  useEffect(() => {
    getWinners();

    // eslint-disable-next-line
  }, []);

  const getWinners = () => {
    setLoading(true);
    api
      .getWinners({
        child_game_id,
      })
      .then(({ winners, child_game }) => {
        setLoading(false);
        const _game = parseData([{ ...child_game }])[0];
        setGame(_game);
        setData(winners);
      })
      .catch(() => {});
  };

  /**
   * get game names and icons
   * based on current app language
   */
  const parseData = (games) => {
    return games.map((item) => {
      return {
        ...item,
        icon:
          lang === CHINESE_LANGUAGE_CODE_LK
            ? item.icon_ch
            : lang === BURMESE_LANGUAGE_CODE_LK
            ? item.icon_mm
            : item.icon_en,
        name:
          lang === CHINESE_LANGUAGE_CODE_LK
            ? item.name_ch
            : lang === BURMESE_LANGUAGE_CODE_LK
            ? item.name_mm
            : item.name_en,
      };
    });
  };

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.POPULAR}/${WINNER_GAMES_LK}`);
  };

  const renderTop = () => (
    <Top>
      <Image src={game.icon} />
      <Title>{t("topWinner.topWinnerSubtitle")}</Title>
    </Top>
  );

  return (
    <RootContainer>
      {loading ? (
        <Loader>
          <Spin />
        </Loader>
      ) : (
        <>
          <Topbar title={game.name} transparent={true} goBack={goBack} />
          {renderTop()}
          <Container>
            {data.map((winner, index) => (
              <Card key={index}>
                <NoCard>
                  <NoText>{index + 1}.</NoText>
                </NoCard>
                <Divider />
                <NameCard>
                  <NameText>{winner.name}</NameText>
                  <PhoneText>{winner.phone}</PhoneText>
                </NameCard>
                <AmountCard>
                  <AmountText>{`${getFormattedNumber(
                    winner.amount
                  )} Ks.`}</AmountText>
                </AmountCard>
              </Card>
            ))}
          </Container>
        </>
      )}
    </RootContainer>
  );
};

export default TopWinners;
